import http from './http';
import { listResource } from './listResource';

export async function listPlanAddons(options = {}) {
  return listResource('/plan-addons', options);
}

/**
 * Obtiene un paquete por su ID.
 */
export async function getPlanAddonById(id) {
  const res = await http.get(`/plan-addons/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Obtiene un paquete por su ID con estatus desactivado.
 */
export async function getPlanAddonByIdAdmin(id) {
  const res = await http.get(`/plan-addons/admin/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza un paquete.
 */
export async function updatePlanAddon(id, data) {
  const res = await http.put(`/plan-addons/${id}`, data);
  return res.data?.data ?? res.data;
}

/**
 * Crear un paquete.
 */
export async function createPlanAddon(data) {
  const res = await http.post(`/plan-addons/`, data);
  return res.data?.data ?? res.data;
}

/**
 * Activar/Desactivar paquete
 */
export const updatePlanAddonStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
http.patch(`/plan-addons/status/${id}`, { is_active: isActive });

/**
 * Eliminar paquete
 */
export const deletePlanAddon = (id) => http.delete(`/plan-addons/${id}`);

/**
 * Revisar que no este en uso el paquete.
 */
export async function checkPlanAddonExists(title, excludeId = null) {
  try {
    const { items } = await listPlanAddons({ search: title });
    const exists = items?.some(
      (item) =>
        item.code?.toLowerCase() === title?.toLowerCase() &&
        item.id !== Number(excludeId)
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar el paquete:', error);
    return false;
  }
}
